export const PRODUCT_TYPES = {
  1: "Car",
  4: "Bike",
  7: "E-scooter",
};

export const TYPE_OF_PROFILE = ["All", "Dealer", "Private"];

export const RECURRING = ["One Time", "Weekly", "Monthly", "Yearly", "daily"];

export const AUCTION_STATUS = {
  in_progress: "active-status",
  upcoming: "progress-status",
  in_registration: "registration-status",
  ended: "end-status",
  registration_ended: "registration-end-status",
};

export const DEBOUNCE_TIME = 500;
export const COMMISSION_RECURRING = ["", "Monthly", "Quarterly", "Yearly"];

export const USER_ACTIVITY_LOG_TYPE = ["", "Created", "Updated", "Deleted"];

export const BID_ACCEPTED = ["status-pending", "status-active", "status-end"];

export const USER_ACTIVE_STATUS = ["Inactive", "Active"];

export const NOMAD_USER_VERIFICATION_STATUS = ["", "Applied", "Verified"];

export const FRONT_OFFICE_USER_VERIFICATION_STATUS = [
  "Not Applied",
  "Applied",
  "Verified",
];

export const SUBSIDIARY = {
  active: "active-status",
  canceled: "registration-end-status",
  incomplete: "end-status",
  past_due: "progress-status",
  incomplete_expired: "end-status",
  unpaid: "progress-status",
};

export const INVOICE_STATUS = {
  paid: "active-status",
  void: "end-status",
  open: "progress-status",
};

export const CENSORED_DURATION = [
  "1 Week",
  "2 Weeks",
  "1 Month",
  "3 Months",
  "1 Day",
  "3 Days",
  "Forever",
];

export const BANNED = [
  "Front Office",
  "Front Office",
  "Front Office",
  "",
  "Nomad",
  "Forum",
];

export const MODULES_DISABLED = {
  0: "App Access",
  1: "Ads",
  2: "Bids",
  4: "App Access",
  5: "Forum",
};

export const APP_TYPE = {
  ADMIN_PANEL: 1,
  FRONT_OFFICE: 2,
  BACK_OFFICE: 3,
};

export const APP_TYPE_INVERSE = {
  1: "Admin Panel",
  2: "Front Office",
  3: "Nomad",
};

export const NOMAD_VALIDATION_TYPE_LIST = [
  "VAT",
  "Dealer Name",
  "Address",
  "Nomad Document",
];

export const WEEKDAYS = {
  MONDAY: 0,
  TUESDAY: 1,
  WEDNESDAY: 2,
  THURSDAY: 3,
  FRIDAY: 4,
  SATURDAY: 5,
  SUNDAY: 6,
};

export const PARTNERS = {
  1: "Salutation",
  2: "Subject",
};

export const FLAGGED_REVIEW_STATUS = {
  All: 1,
  Active: 2,
  Deleted: 3,
  "No action": 4,
};

export const MAPPED_VALUES = {
  "Non-Assigned": 0,
  Assigned: 1,
};

export const DATA_PROVIDER_ERROR_FILTER = {
  Retry: 1,
  Error: 2,
};

export const ASPECT_RATIOS = {
  HOME: 3 / 1,
  PARTNER: 4 / 3,
};

export const ADD_SLIDER_TYPE = {
  HOME: 2,
  PARTNER: 1,
};
export const PROVIDERS = [
  { value: 1, name: "MODIX" },
  { value: 2, name: "CARDIFF" },
  { value: 3, name: "UBIFLOW" },
  { value: 4, name: "Volkswagen" },
  { value: 5, name: "Autoscout" },
  { value: 6, name: "Fastback" },
];

export const ADVERTISERS_PROVIDERS = [
  { id: 3, name: "UBIFLOW" },
  { id: 5, name: "Autoscout" },
];

export const modelType = {
  brand: 8,
};

export const verificationIdTypes = {
  drivingLicense: 1,
  passport: 2,
  selfie: 3,
  nationalId: 4,
};

export const verificationIdsCollectionName = {
  nationalIdFront: "national_id_front",
  nationalIdBack: "national_id_back",
  drivingLicenseFront: "driving_license_front",
  drivingLicenseBack: "driving_license_back",
  selfieWithId: "selfie_with_id_document",
  passport: "passport",
};

export const ProductTypes = {
  car: 1,
  bike: 4,
  scooter: 7,
};

export const userTypes = {
  Dealer: 1,
  Private: 2,
};

export const auctionUserTypes = {
  All: 0,
  Dealer: 1,
  Private: 2,
};

export const frequencies = {
  "One Time": 0,
  Weekly: 1,
  Monthly: 2,
  Yearly: 3,
};

export const typeOfSale = {
  0: "Classic",
  1: "Auction",
  2: "Rent",
  3: "Hotdeal",
};

export const typeOfSaleInverse = {
  Classic: 0,
  Auction: 1,
  Rent: 2,
  Hotdeal: 3,
};

export const auctionStatus = {
  "In progress": "in_progress",
  Upcoming: "upcoming",
  "In Registration": "in_registration",
  Ended: "ended",
  "Registration Ended": "registration_ended",
};

export const adsValidStatus = {
  "Only Unvalidated": 0,
  "Only Validated": 1,
};

export const adsOnlineStatus = {
  Offline: 0,
  Online: 1,
};

export const sellerType = {
  "Verified User": "private_verified",
  "Unverified User": "private_unverified",
  "Verified Subsidiary": "subsidiary_verified",
  "Unverified Subsidiary": "subsidiary_unverified",
};

export const bidPercents = {
  "35 %": "35",
  "50 %": "50",
  "70 %": "70",
};

export const AccountCreationDates = {
  Yesterday: "1",
  "Last 3 Days": "2",
  "Last 1 Week": "3",
  "Current Month": "4",
  "Previous Month": "5",
  "Custom (To and From)": "6",
};

export const AccountCreationDatesType = {
  YESTERDAY: "1",
  LAST_3_DAYS: "2",
  LAST_1_WEEK: "3",
  CURRENT_MONTH: "4",
  PREVIOUS_MONTH: "5",
  CUSTOM_TO_AND_FROM: "6",
};

export const ProfileCompletionStatus = {
  Complete: "1",
  Incomplete: "0",
};

export const verifiedProfileStatus = {
  Active: "1",
  Inactive: "0",
};

export const verificationStatus = {
  "Not Applied": "0",
  Applied: "1",
  Verified: "2",
};

export const productStatusOptions = {
  Active: "active",
  Canceled: "canceled",
  Cancelling: "cancelling",
  Incomplete: "incomplete",
  "Past Due": "past_due",
  "Incomplete Expired": "incomplete_expired",
};

export const AdReportReasons = {
  "Fraudulent Ad": 1,
  "Vehicle already sold": 2,
  "Incorrect vehicle details": 3,
  "Nudity/Sexual content": 4,
  Other: 5,
};

export const AdReportStatus = {
  0: "Pending",
  1: "Accepted",
  2: "Rejected",
};

export const userRoleOptions = {
  Admin: "1",
  Nomad: "3",
};

export const couponTypeOptions = {
  Subscriptions: 1,
  Credits: 2,
};

export const validationOptions = {
  Valid: "1",
  Invalid: "0",
};

export const subscriptionOptions = {
  Forever: "forever",
  Once: "once",
  Repeating: "repeating",
};

export const paymentStatusOptions = {
  Paid: "2",
  Pending: "1",
};

export const supportedExtensionForIcons = {
  web: ["svg"],
  mobile: ["webp", "png"],
};

export const userTypeName = {
  DEALER: "Dealer",
  PRIVATE: "Private",
  DEALER_CAPITAL: "DEALER",
};

export const couponTypeName = {
  SUBSCRIPTIONS: "Subscriptions",
  CREDITS: "Credits",
};

export const planType = {
  RECURRING: "recurring",
  ONE_TIME: "one_time",
};

export const siteSettingTabs = [
  { type: 1, name: "Hotdeals" },
  { type: 2, name: "Miscellaneous" },
  { type: 3, name: "Chat limit settings" },
  { type: 5, name: "Auction settings" },
];

export const siteSettingTabsObj = {
  hotdeal: 1,
  miscellaneous: 2,
  chatSettings: 3,
  auctionSettings: 5,
};

export const SITE_SETTING_KEY_NAMES = {
  PURCHASE_BLOCK_TIME: "purchase_block_time",
  VIDEO_URL: "video_url",
  HOTDEALS_NOTIFICATION_DAYS_SOLD_NO_ACTION:
    "hotdeals_notification_days_sold_no_action",
  HOTDEALS_PAYMENT_RELEASE_DELAY_DAYS: "hotdeals_payment_release_delay_days",
  HOTDEALS_BUYER_CONFIRMATION_DAYS: "hotdeals_buyer_confirmation_days",
  MAINTENANCE_MODE: "maintenance_mode",
  CLASSIC_ADS_SETTINGS: "allow_classic_ad_posting_unverified_users",
  AUCTION_ADS_SETTINGS: "allow_auction_ad_posting_unverified_users",
  CONTACT_NUMBER_FOR_PROFESSIONALS:
    "customer_service_exclusively_for_professionals",
  CONTACT_NUMBER_FOR_PRIVATE_USERS:
    "customer_service_exclusively_for_private_users",
  AUCTION_PARTICIPATION_FEE: "auction_participation_fee",
  PLATFORM_HANDLING_FEE: "platform_handling_fee",
  AUCTION_REFUND_PROCESS_IN_DAYS:
    "automatic_refund_processing_after_no_action_in_days",
};

export const recurringFrequencyValue = {
  WEEKLY: "1",
  MONTHLY: "2",
  YEARLY: "3",
  DAILY: "4",
};

export const commissionTypeOptions = {
  "Nomad commission": "1",
  "Vehicle sale commission": "2",
};

export const userConfig = {
  user: {
    field: "user_id",
  },
  subsidiary: {
    field: "subsidiary_id",
  },
};

export const creditTypes = {
  PURCHASED: 1,
  USED: 2,
  EXPIRED: 3,
  ADDED_BY_ADMIN: 4,
  REFUNDED: 5,
  LICENSE_SEARCH: 6,
  REMOVED_BY_ADMIN: 7,
};

export const suggestionText = {
  VERIFICATION_REJECT: 0,
  USER_CENSORSHIP: 1,
  NOMAD_PROFILE: 2,
  SUBSIDIARY_CENSORSHIP: 3,
  AD_DELETED: 4,
  ADD_CREDIT: 5,
  FORUM_CENSORSHIP: 6,
  DEPOSIT_HISTORY_REJECTION: 7,
  BLOCKED_CHAT_MESSAGES: 8,
};

export const requestType = {
  SELLER: 1,
  BUYER: 2,
};

export const approvalStatus = {
  ACCEPT: 1,
  REJECT: 2,
  REJECTWITHPENALTY: 3,
};

export const penaltyType = {
  WITH_PENALTY: 1,
  WITHOUT_PENALTY: 2,
};

export const userTypeTypo = {
  USER: "user",
  SUBSIDIARY: "subsidiary",
};

export const forumFlagModelType = {
  QUESTION: "question",
  ANSWER: "answer",
};

export const forumFlagModelTypeOptions = {
  All: "",
  Question: "question",
  Answer: "answer",
};

export const actionTypeOptions = {
  All: "",
  Approved: 1,
  Rejected: 2,
  "Pending actions": 3,
};

export const refundRequestTypeOptions = {
  All: "",
  "Pre sale": 1,
  "Post sale": 2,
};

export const refundRequestTypeText = {
  PRE_SALE: "Pre sale",
  POST_SALE: "Post sale",
};

export const refundRequestType = {
  PRE_SALE: 1,
  POST_SALE: 2,
};

export const USER_TYPE = {
  ADMIN_PANEL: "1",
  FRONT_OFFICE: "2",
  BACK_OFFICE: "3", // NOMAD
  FORUM: "4",
};

export const USER_TYPE_TEXT = {
  ADMIN_PANEL: "adminPanel",
  FRONT_OFFICE: "frontOffice",
  BACK_OFFICE: "backOffice", // NOMAD
  FORUM: "forum",
};

export const notificationType = {
  IMPORTED_DEALER: "imported_dealer",
  FLAGGED_RATING: "flagged_rating",
  PARTNER: "partner",
  INVITATION: "invitation",
  CONTACT_US: "contact_us",
  HOTDEAL: "hotdeal",
  AUCTION: "auction",
};

export const refundStatus = {
  APPLIED: 1,
  NOT_APPLIED: 2,
};

export const penaltyText = {
  1: "with penalty",
  2: "without penalty",
};

export const PAYMENT_TYPE = {
  CREDIT_BUY: 1,
  VEHICLE_BUY: 2,
  SUBSCRIPTION: 3,
  SPOMSERSHIP: 5,
};

export const invoiceTabs = {
  SUBSCRIPTION: "subscription",
  CREDIT: "credit",
  COMMISSION: "commission",
  NOMAD: "nomad",
  AUCTION: "auction",
  SPONSORSHIP: "sponsership",
};

export const refundOption = {
  FULL_REFUND: 1,
  CUSTOME_REFUND: 2,
};

export const vehicleStatus = {
  SELLER_NO_ACTION: { id: 1, label: "Seller no action" },
  BUYER_NO_ACTION: { id: 2, label: "Buyer no action" },
  SELLER_CANCEL_RESERVATION_REQUEST: {
    id: 3,
    label: "Seller cancel reservation request",
  },
  BUYER_CANCEL_RESERVATION_REQUEST: {
    id: 4,
    label: "Buyer cancel reservation request",
  },
  CANCEL_RESERVATION_REQUEST_ACCEPTED: {
    id: 5,
    label: "Cancel reservation request accepted",
  },
  SALE_COMPLETED: { id: 6, label: "Sale completed" },
};

export const paymentStatus = {
  ESCROW: { id: 1, label: "Escrow" },
  PAID: { id: 2, label: "Paid" },
  REFUND_INITIATED: { id: 3, label: "Refund initiated" },
  AMOUNT_REFUNDED: { id: 4, label: "Amount refunded" },
  AMOUNT_NOT_REFUNDED: { id: 5, label: "Amount not refunded" },
};

export const pendingAction = {
  SELLER_ACTION_PENDING: { id: 1, label: "Seller action pending" },
  BUYER_ACTION_PENDING: { id: 2, label: "Buyer action pending" },
  ALL_PENDING_RECORDS: { id: 3, label: "All pending records" },
  VEHICLE_ACTION_REQUIRED_15_DAYS_PASSED: {
    id: 4,
    label: "Vehicle action required 15 days passed",
  },
};

export const visitorsMethodsTypes = {
  view: 1,
  call: 2,
  chat: 3,
};

export const editNameAndAddressSteps = {
  userName: 1,
  userAddress: 2,
};

export const creditExpensType = {
  PURCHASED: 1,
  USED: 2,
  EXPIRED: 3,
  ADDED: 4,
  REFUNDED: 5,
  LICENSESEARCH: 6,
};

export const hotdealDiscountType = {
  applied: 1,
  notApplied: 0,
};

export const screenNames = [
  { value: "ClassicAd", name: "Classic ad list" },
  { value: "AuctionEvent", name: "Auction event list" },
  { value: "ContactUs", name: "Contact us" },
  { value: "CreateSubsidiary", name: "Company list" },
  { value: "CreditPlansScreen", name: "Credit plan screen" },
  { value: "CreditScreen", name: "Wallet screen" },
  { value: "DashboardStackNavigator", name: "Home page" },
  { value: "EditUserProfile", name: "Edit profile" },
  { value: "InvoiceList", name: "Bills" },
  { value: "LicensePlateScreen", name: "License plate" },
  { value: "Myads", name: "My ads" },
  { value: "Park", name: "My orders" },
  { value: "PaymentCards", name: "Payment method" },
  { value: "UserSetting", name: "Settings" },
  { value: "VerifyIdScreen", name: "Verify Id screen" },
];
export const deviceTypes = [
  { value: 1, name: "IOS" },
  { value: 2, name: "Android" },
  { value: 3, name: "Web" },
  { value: 4, name: "All" },
];

export const chatLimits = {
  1: "10-minute",
  2: "hourly",
  3: "daily",
};

export const OSTYPE = {
  IOS: 1,
  ANDROID: 2,
};

export const OSTYPE_INVERSE = {
  1: "iOS",
  2: "Android",
};

export const versionRegex = /^\d+\.\d+\.\d+$/;

// Platform slugs the OTA API uses in URLs, keyed by OSTYPE id.
export const OTA_PLATFORM_SLUG = {
  1: "ios",
  2: "android",
};

export const OTA_FILE_TYPE = {
  MANIFEST: "manifest",
  JSBUNDLE: "jsbundle",
};

export const FAQ_TYPE = {
  1: "Standard",
  2: "Auction",
  3: "Hot Deal",
  4: "Classic",
  5: "Deposits",
};

export const FAQ_TYPE_INVERSE = {
  Standard: 1,
  Auction: 2,
  "Hot Deal": 3,
  Classic: 4,
  Deposits: 5,
  Sponserships: 6,
};

export const DEPOSITHISTORYSTATUS = {
  0: "Amount Deposited",
  1: "Refund Requested",
  2: "Refund Approved (Manual)",
  3: "Refund Approved (Automatic)",
  4: "Refund Rejected",
  5: "Refund Failed",
  6: "Refund Paid (Automatic)",
  7: "Refund Paid (Manual)",
};
export const DEPOSITHISTORYSTATUSINVERSE = {
  AMOUNT_DEPOSITED: 0,
  REFUND_REQUESTED: 1,
  REFUND_APPROVED_MANUALLY: 2,
  REFUND_APPROVED_AUTOMATICALLY: 3,
  REFUND_REJECTED: 4,
  REFUND_FAILED: 5,
  REFUND_PAID_AUTOMATICALLY: 6,
  REFUND_PAID_MANUALLY: 7,
};

export const CHATREPORTSTATUS = {
  Pending: 0,
  Accepted: 1,
  Rejected: 2,
};

export const FLAGSTATUS = {
  'Flagged': 1,
  'Non Flagged': 0,
  'Exempted': 2
};

export const MARKED_AS_SCAMMER = {
  "All": '',
  "Scammer": 1,
  "Not scammer": 0
}

export const REASON_TO_MARK_SCAMMER = {
  BY_CTB_FOR_FAKE_AD: 1,
  BY_CTB_FOR_THE_MESSAGE: 2,
  BY_CTB_FOR_FAKE_ID: 3,
}

export const REASON_TO_MARK_SCAMMER_INVERSE = {
  1: 'By CTB for fake ad',
  2: 'By CTB for the message',
  3: 'By CTB for fake ID'
}

export const ASSISTANCE_REQUEST_STATUS = {
  'PENDING': 0,
  'IN_PROGRESS': 1,
  'COMPLETED': 2,
  'NOT_CONVERTED': 3
}

export const ASSISTANCE_REQUEST_STATUS_INVERSE = {
  [ASSISTANCE_REQUEST_STATUS['PENDING']]: 'Pending',
  [ASSISTANCE_REQUEST_STATUS['IN_PROGRESS']]: 'In progress',
  [ASSISTANCE_REQUEST_STATUS['COMPLETED']]: 'Completed',
  [ASSISTANCE_REQUEST_STATUS['NOT_CONVERTED']]: 'Not converted',
}

export const HOLD_DEPOSIT_STATUS = {
  'DISPUTE_BY_SELLER': 1,
  'DISPUTE_BY_BUYER': 2,
  'SELLER_ACTION_PENDING': 3,
  'BUYER_ACTION_PENDING': 4
}

export const HOLD_DEPOSIT_STATUS_INVERSE = {
  [HOLD_DEPOSIT_STATUS['DISPUTE_BY_SELLER']]: 'Cancellation requested by seller',
  [HOLD_DEPOSIT_STATUS['DISPUTE_BY_BUYER']]: 'Dispute raised by buyer',
  [HOLD_DEPOSIT_STATUS['SELLER_ACTION_PENDING']]: 'Seller action pending',
  [HOLD_DEPOSIT_STATUS['BUYER_ACTION_PENDING']]: 'Buyer action pending',
}

export const PLAN_TYPES = {
  CREDIT: 'credit',
  SPONSOR: 'sponsor',
  SUBSCRIPTION: 'subscription',
}

export const TRANSLATION_FILE_TYPE = {
  MOBILE: 6,
  WEB: 7,
};

export const TRANSLATION_FILE_TABS = [
  { type: TRANSLATION_FILE_TYPE.MOBILE, name: "Mobile" },
  { type: TRANSLATION_FILE_TYPE.WEB, name: "Web" },
];

/** Supported translation file languages for admin upload/download */
export const TRANSLATION_UPLOAD_LANGUAGES = [
  { code: "en", name: "English" },
  { code: "fr", name: "French" },
  { code: "de", name: "German" },
  { code: "es", name: "Spanish" },
  { code: "nl", name: "Dutch" },
];
